const USE_DEV_INDEX = false;

export const ALGOLIA_PRODUCTS_INDEX = USE_DEV_INDEX ? "products-index-dev" : "products-index";

export const ALGOLIA_ANALYTICS_INDEX = `${ALGOLIA_PRODUCTS_INDEX}_query_suggestions`;

export const ALGOLIA_HITS_PER_PAGE = 20;

export const ALGOLIA_SORT_INDEXES = {
	default: `${ALGOLIA_PRODUCTS_INDEX}`,
	newest: `${ALGOLIA_PRODUCTS_INDEX}_skuRank_asc`,
	oldest: `${ALGOLIA_PRODUCTS_INDEX}_skuRank_desc`,
	name_asc: `${ALGOLIA_PRODUCTS_INDEX}_name_asc`,
	name_desc: `${ALGOLIA_PRODUCTS_INDEX}_name_desc`,
} as const;

export const ALGOLIA_ARTICLES_INDEX = "articles-index";
